// HISTÓRICO CONGELADO F3d (proveedoresRecurrentes — licencias OnSign): copia literal del conteo de pantallas de
// cartelería de `contarPantallasActivas` (la parte que sigue a la query de `negocios_carteleria`). Producción lo
// usa para fechas < 2026-10-01 (CORTE_HISTORICO).
export const contarPantallasNegociosHistorico = (negocios, fecha) => {
  let total = 0;
  for (const n of negocios || []) {
    if (!n.cantidad_pantallas) continue;
    if (n.plazo_contrato_meses && n.fecha_inicio) {
      const fechaFin = new Date(n.fecha_inicio);
      fechaFin.setMonth(fechaFin.getMonth() + parseInt(n.plazo_contrato_meses, 10));
      const fechaFinStr = fechaFin.toISOString().split("T")[0];
      if (fechaFinStr < fecha) continue;
    }
    total += Number(n.cantidad_pantallas);
  }
  return total;
};
